import { useState, useEffect } from "react";
import {
    Outlet,
    Link,
    useLoaderData,
    NavLink
  } from "react-router-dom";

import * as API from "../services/especialistas";


export async function loader() {
  const especialistas = await API.getAllEspecialistas();
  return { especialistas };
}

export function EspecialistaAdminList() {
  const { especialistas } = useLoaderData();
  const [especialistaList, setEspecialistaList] = useState();
  const [especialistaQuery, setEspecialistaQuery] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        await API.getSearchEspecialistasAndAdmins(
          especialistaQuery
        ).then(
          (val) => {
            setEspecialistaList(val);
          },
          (error) => {
            console.log(error);
          }
        );
      } catch (err) {
        console.log(err);
      }
    }

    fetchData();
}, [especialistaQuery])
  return (
    <>
      <div id='content'>
        <div id='formNewElement'>
            <div className='field'>
              <label htmlFor='especialistaQuery'>Buscar Especialista</label>
              <div className='control'>
                <input
                  className='input'
                  id='especialistaQuery'
                  required
                  type='text'
                  value={especialistaQuery}
                  onChange={(e) => setEspecialistaQuery(e.target.value)}
                />
              </div>
            </div>
      
          {especialistaList?.length ? (
            <ul>
            {console.log(especialistaList)}
              {especialistaList.map((especialista) => (
                <li key={especialista.id}>
                  <Link to={`${especialista.id}`}>
                  {especialista.display_name}
                  </Link>
                </li>
              ))}
            </ul>
          ) : (
            <p>
              <i>Sin especialistas</i>
            </p>
          )}

        </div>
      </div>
      <div id="actions">
        {<Link className="button is-link" to={`new`}>Nuevo</Link>}
      </div>

    </>
  );
}